<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "kyc-modal-Modify",
        "hide-footer": "",
        centered: "",
        size: "sm",
      },
      on: {
        hide: function ($event) {
          return _vm.onModalHidden(false)
        },
      },
      model: {
        value: _vm.modalVisible,
        callback: function ($$v) {
          _vm.modalVisible = $$v
        },
        expression: "modalVisible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "icon-bg head-top-15 warn-bg" },
        [
          _c("feather-icon", {
            attrs: { icon: "AlertTriangleIcon", size: "38" },
          }),
        ],
        1
      ),
      _c("h4", { staticClass: "mb-1 text-center" }, [
        _vm._v(_vm._s(_vm.msg ? _vm.msg : _vm.$t("Kyc.kycNotComplete"))),
      ]),
      !!_vm.showButton
        ? _c(
            "div",
            { staticClass: "d-block text-center mt-2 mb-2" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$router.push({
                        name: "verification",
                        params: { lang: _vm.lang || undefined },
                      })
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("feedbback.Get-Verified")))]
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/KycNotComplete.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default ({
  render,
  staticRenderFns,
  name: "KycNotComplete",
  props: {
    showPop: {
      type: Boolean,
      isRequired: false,
      default: false
    },
    onModalHidden: {
      type: Function,
      isRequired: true,
      default: () => {}
    },
    msg: {
      type: String,
      isRequired: true,
      default: ""
    },
    showButton: {
      type: Boolean,
      default: true
    }
  },
  components: {
    BModal: bootstrapvue["BModal"],
    BButton: bootstrapvue["BButton"],
    BFormFile: bootstrapvue["BFormFile"],
    BImg: bootstrapvue["BImg"],
    BRow: bootstrapvue["BRow"],
    BCol: bootstrapvue["BCol"],
    BInputGroup: bootstrapvue["BInputGroup"],
    BFormInput: bootstrapvue["BFormInput"],
    BFormGroup: bootstrapvue["BFormGroup"]
  },
  data() {
    return {
      modalVisible: this.showPop,
      lang: this.$route.params.lang
    };
  },
  mounted() {},
  watch: {
    showPop(newValue) {
      this.modalVisible = newValue;
    }
  },
  methods: {}
});

//# sourceURL=webpack:///./src/layouts/components/KycNotComplete.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.camera {
  width: 100%;
  height: 100%;
}
.camera {
  width: 100%;
  height: 100%;
}
.camera {
  width: 100%;
  height: 100%;
}
</style>
